import React from 'react';
import { createContainer } from 'react-tracked';
import { find_rate_in_group, rate_calculation, rate_chunks, rate_visualization, specific_rate_calculation, updateRentalItemsAvailability } from "../Utils";

const useValueReservationCart = () => React.useState({ cart: [], fees_data: {} });

export const { Provider: ReservationCartState, useTracked: useTrackedReservationCart } = createContainer(useValueReservationCart, { concurrentMode: true });

export const update_cart = (reservationCart, reservation_length, reserveStartDate, reserveEndDate, setter) => {
    reservationCart.cart.forEach((item) => {
        const rate_group = find_rate_in_group(item.rental_type.rental_rate_group.rental_rates, item.quantity)
        item.calculated_rate = specific_rate_calculation(rate_group.rental_rates, reservation_length, item.quantity)
        item.calculated_rate_visualization = rate_visualization(rate_chunks(rate_calculation(rate_group.rental_rates, 10000, item.quantity)[0]), 1000, reservation_length)
        let total = item.calculated_rate
        for (const fee_index in item.rental_type.fees) {
            const fee = item.rental_type.fees[fee_index]
            if (!fee.optional || reservationCart.fees_data?.[item.id]?.[fee.id]?.["optional_selection"]) {
                if (fee.fee_type === 'PERCENTAGE') {
                    total += item.calculated_rate * (fee.calculation / 100)
                }
                else if (fee.fee_type === 'FLAT_RATE') {
                    total += fee.calculation
                }
                else if (fee.fee_type === 'FLAT_RATE_PER_ITEM') {
                    total += fee.calculation * item.quantity
                }
            }
        }
        item.calculated_pretax_total = total
        item.calculated_tax = ((item.location.tax_rate || 0) / 100) * item.calculated_pretax_total
        item.calculated_posttax_total = item.calculated_pretax_total + item.calculated_tax
        // Calculate deposit
        if (item.rental_type.deposit_type === 'FLAT_RATE') {
            item.calculated_deposit = item.rental_type.deposit_calculation
        } else if (item.rental_type.deposit_type === 'FLAT_RATE_PER_ITEM') {
            item.calculated_deposit = item.rental_type.deposit_calculation * item.quantity
        } else if (item.rental_type.deposit_type === 'PERCENTAGE') {
            if (item.rental_type.deposit_include_fees) {
                item.calculated_deposit = (item.rental_type.deposit_calculation / 100) * item.calculated_posttax_total
            } else {
                item.calculated_deposit = (item.rental_type.deposit_calculation / 100) * item.calculated_rate
            }
        } else {
            item.calculated_deposit = 0
        }
        // Calculate availability
        updateRentalItemsAvailability(item, reserveStartDate, reserveEndDate)
    })
    setter({ ...reservationCart })
}